import { render, staticRenderFns } from "./UserHeaderFields.vue?vue&type=template&id=5868d932&scoped=true&"
import script from "./UserHeaderFields.vue?vue&type=script&lang=ts&"
export * from "./UserHeaderFields.vue?vue&type=script&lang=ts&"
import style0 from "./UserHeaderFields.vue?vue&type=style&index=0&id=5868d932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868d932",
  null
  
)

export default component.exports